"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "SVBButton", {
  enumerable: true,
  get: function get() {
    return _SVBButton.default;
  }
});
var _SVBButton = _interopRequireDefault(require("./src/SVBButton"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }